<script setup>
    defineProps({
        type: {
            type: String,
            default: 'submit',
        },
    })
</script>

<template>
    <button
        :type="type"
        class="bg-brand-primary inline-flex items-center rounded-md border border-transparent px-4 py-2 text-xs font-semibold tracking-widest text-white uppercase transition duration-150 ease-in-out focus:ring-2 focus:ring-green-500 focus:ring-offset-2 focus:outline-none active:bg-green-900 disabled:opacity-50"
    >
        <slot />
    </button>
</template>
